import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { useAuth, AuthProvider } from './auth-context';
import App from './App';
import './index.css';
import Pricing from './pricing';
import Success from './success';
import PracticeTest from './practice';
import ReportsDashboard from './reports';
import Flashcards from './flashcards';
import SessionsHistory from './sessions';
import Legal from './legal';

const ProtectedRoute = ({ children }) => {
  const { user } = useAuth();
  if (!user) {
    return <Navigate to="/" state={{ showSignIn: true }} replace />;
  }
  return children;
};

const Root = () => (
  <BrowserRouter>
    <AuthProvider>
      <Routes>
        <Route path="/" element={<App />} />

        {/* Public Routes */}
        <Route path="/success" element={<Success />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/legal" element={<Legal />} />

        {/* Protected Routes */}
        <Route path="/practice" element={
          <ProtectedRoute>
            <PracticeTest />
          </ProtectedRoute>
        } />
        <Route path="/reports" element={
          <ProtectedRoute>
            <ReportsDashboard />
          </ProtectedRoute>
        } />
        <Route path="/flashcards" element={
          <ProtectedRoute>
            <Flashcards />
          </ProtectedRoute>
        } />
        <Route path="/sessions" element={
          <ProtectedRoute>
            <SessionsHistory />
          </ProtectedRoute>
        } />
      </Routes>
    </AuthProvider>
  </BrowserRouter>
);

const root = createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Root />
  </React.StrictMode>
);
